import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "details-form__item" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "profile-creation-wizard__side" }, null, -1)

import {SeniorityLevel} from '@/profile-creation-wizard/components/for-completion/domain/types';
    import SeniorityLevelSelection from '@/profile-creation-wizard/components/for-completion/ui/7_privacy/SeniorityLevelSelection.vue';
    import {ref, computed} from 'vue';
    import Step from '@/profile-creation-wizard/common/ui/step/Step.vue';
    import {useRouter} from 'vue-router';
    import {useStore} from 'vuex';
    import actions from '@/profile-creation-wizard/store/completion/actions';
    import getters from '@/profile-creation-wizard/store/completion/getters';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'StrategyPrivacyStep',
  setup(__props) {

    const router = useRouter();
    const store = useStore();

    const isLoadingButtonFinish = ref(false);
    const hasValidFieldPart = computed(() => seniorityLevel.value != null);
    const seniorityLevel = computed(() => store.getters[getters.seniority]);

    async function selectSeniorityLevel(seniorityLevel: string | null): Promise<void> {
        const selectedSeniorityLevel = seniorityLevel ? SeniorityLevel[seniorityLevel] : null;
        isLoadingButtonFinish.value = true;
        await saveSeniorityLevelSelection(selectedSeniorityLevel);
        isLoadingButtonFinish.value = false;
    }

    async function goNext(): Promise<void> {
        router.push({name: router.currentRoute.value.meta.nextStep});
    }

    async function saveSeniorityLevelSelection(seniorityLevelSelection: SeniorityLevel | null): Promise<void> {
        await store.dispatch(actions.updateSeniority, seniorityLevelSelection);
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Step, {
    "is-step-valid": hasValidFieldPart.value,
    "show-skip-step": true,
    "is-loading": isLoadingButtonFinish.value,
    "is-skip-enabled": !hasValidFieldPart.value,
    onGoToNext: goNext
  }, {
    "step-content": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(SeniorityLevelSelection, {
          class: "seniority-level-selection",
          "seniority-level": seniorityLevel.value,
          "bottom-sheet-selector-prop": "#seniority-level-bottom-sheet",
          "data-heap-tooltip-id-prop": "profile-creation-tooltip-seniority-level",
          onSeniorityLevelSelected: selectSeniorityLevel
        }, null, 8, ["seniority-level"])
      ])
    ]),
    "step-side": _withCtx(() => [
      _hoisted_2
    ]),
    _: 1
  }, 8, ["is-step-valid", "is-loading", "is-skip-enabled"]))
}
}

})